import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvPaginatorComponent } from '../../../../Shared/Components/av-paginator/av-paginator.component';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { BillingDocumentsFacade } from '../../../../../Facades/Billing/billing-documents.facade';
import { DATE_FORMAT, VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';
import { INVOICE_STATUS_LABEL, INVOICE_STATUS_OPTIONS } from '../../../../../Enums/stripe-status.enum';
import { InvoiceFilters } from '../../../Interfaces/billing-dialog.interface';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'av-invoice-table',
  standalone: true,
  imports: [
    RouterLink,
    DatePipe,
    DecimalPipe,
    MatIconModule,
    MatTooltipModule,
    AvEmptyStateComponent,
    AvPaginatorComponent,
    AvStatusChipComponent,
    TranslateModule,
  ],
  templateUrl: './invoice-table.component.html',
  styleUrl: './invoice-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class InvoiceTableComponent {
  readonly facade = inject(BillingDocumentsFacade);

  readonly dateFormat = DATE_FORMAT;
  readonly unresolved = VALUE_UNRESOLVED;
  readonly statusOptions = INVOICE_STATUS_OPTIONS;
  readonly statusLabelKeys = INVOICE_STATUS_LABEL;

  readonly isEmpty = computed<boolean>(
    () => this.facade.invoicesState() === 'ready' && this.facade.invoices().length === 0,
  );

  changeFilter(field: keyof InvoiceFilters, value: string): void {
    this.facade.applyInvoiceFilters({ ...this.facade.invoiceFilters(), [field]: value });
  }

  clearFilters(): void {
    this.facade.clearInvoiceFilters();
  }

  openDocument(invoiceId: string): void {
    this.facade.openDocument(invoiceId);
  }

  goToPage(page: number): void {
    this.facade.goToInvoicePage(page);
  }

  changePageSize(pageSize: number): void {
    this.facade.changePageSize(pageSize);
  }
}
